import {Component, Input, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {TaskService} from '../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'nf-task-handle',
  templateUrl: './task-handle.component.html',
  styleUrls: ['./task-handle.component.css']
})
export class TaskHandleComponent implements OnInit {
  dataSubscription: Subscription = null;
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  group: any = {}; // 当前组件分组数据
  pulse: any = {}; // 当前组件行数据
  column: any = {}; // 当前组件列数据
  nfDisabled = false;
  @Input('nfBoardData') set ChangeBoardData(data: any) {
    if (data) {
      this.boardData = data;
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
  }
  @Input('nfColumnData') set ChangeColumnData(data: any) {
    if (data) {
      this.column = data;
    }
  }
  @Input('nfPulseData') set ChangePulseData(data: any) {
    if (data) {
      this.pulse = data;
    }
  }
  @Input('nfDisabled') set ChangeDisabled(val: boolean) {
    this.nfDisabled = val;
  }
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
  }
  selectChange(event) {
    const param = {};
    param['pulseIds'] = [this.pulse.id];
    param['columnId'] = this.column.id;
    param['columnValue'] = this.pulse.columnValues[this.column.id];
    this.dataSubscription = this.taskService.doEditPulse(this.boardData.id, param).subscribe((res: any) => {});
  }
}
